import { EditOutline18Icon } from "@vygruppen/spor-icon-react";

import NewLogMessageModal from "features/CenterContent/RoleContent/ISirk/NewLogMessageModal";
import ReadLogMessagesModal from "features/CenterContent/RoleContent/ISirk/ReadLogMessagesModal";
import { FC, useState } from "react";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import { DropsButton, HStack } from "shared/components/Spor";
import { useISirkLogMessages } from "features/CenterContent/RoleContent/ISirk/useISirkLogMessages";

type ISirkLogButtonsProps = { isirk: string };

const ISirkLogButtons: FC<ISirkLogButtonsProps> = ({ isirk }) => {
  const [showNewLogMessageModal, setShowNewLogMessageModal] = useState(false);
  const [showReadLogMessagesModal, setShowReadLogMessagesModal] =
    useState(false);

  const { isError, isSuccess, data } = useISirkLogMessages(isirk);

  return (
    <HStack minWidth="100%" pt="6px" pb="6px" justifyContent="flex-end">
      <DropsButton
        leftIcon={<EditOutline18Icon />}
        variant="secondary"
        size="sm"
        onClick={() => setShowNewLogMessageModal(true)}
      >
        Ny loggmelding
      </DropsButton>
      {isSuccess && data && data.incidentLogs.length > 0 && (
        <>
          <DropsButton
            variant="tertiary"
            size="sm"
            onClick={() => setShowReadLogMessagesModal(true)}
          >
            Se loggmeldinger ({data.incidentLogs.length})
          </DropsButton>
          <ReadLogMessagesModal
            open={showReadLogMessagesModal}
            setopen={setShowReadLogMessagesModal}
            isirkId={isirk}
            messages={data.incidentLogs || []}
          />
        </>
      )}
      {isError && (
        <FailureMessage customMessage="Feil med henting av loggmelding" />
      )}
      <NewLogMessageModal
        isirkId={isirk}
        open={showNewLogMessageModal}
        setopen={setShowNewLogMessageModal}
      />
    </HStack>
  );
};

export default ISirkLogButtons;
